import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TableLineageCountsFragmentGql } from './TableLineageCountsFragmentGql';

export const TableLineageCountsFilteredByColumnQueryGql: DocumentNode = gql`
query TableLineageCountsFilteredByColumnQuery($tableId: ID!, $columnId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  tables(filter: { id: $tableId }) {
    ...TableLineageCountsFragment
    filteredColumnsConnection: columnsConnection(filter: { id: $columnId }) {
      nodes {
        name
        id
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
          totalCount
        }
        downstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
${TableLineageCountsFragmentGql}
`;
